import axios from "axios";
import type { AntePoolFromAPI } from "types";

function getApiBaseUrl(): string {
  const env = process.env.REACT_APP_API_URL;
  if (env) return env.replace(/\/$/, "");
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}

/**
 * Filter params for use in hooks only. The API returns all records; filtering is done locally.
 */
export type FetchAntePoolsParams = {
  chainId?: string;
  anteTestAddress?: string;
  anteTestAddresses?: string[];
  isVisible?: boolean;
};

/**
 * Fetches all AntePools from the REST API at GET /antepools (no query params).
 * Use formatPools() on the result for UI; filter in hooks with handlePoolFilters.
 *
 * @returns Array of all pools in API shape
 */
export async function fetchAntePoolsFromAPI(): Promise<AntePoolFromAPI[]> {
  const base = getApiBaseUrl();
  const url = base ? `${base}/antepools` : "/antepools";

  const response = await axios.get<AntePoolFromAPI[]>(url, {
    headers: { Accept: "application/json" },
    withCredentials: true,
  });

  const data = response.data;
  return Array.isArray(data) ? data : [];
}
